module.exports = __webpack_public_path__ + "img/unicredit-regular.9bf9688c.svg";